/**
 * @generated SignedSource<<329d37a5be7feae10348f28236dabb8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type StorecastDeviceInfoStatus = "negative" | "positive" | "semiNegative";
export type InfoSubscription$variables = {
  screenId: string;
};
export type InfoSubscription$data = {
  readonly storecastScreenInfoChange: {
    readonly info: {
      readonly language: string | null;
      readonly languageStatus: StorecastDeviceInfoStatus;
      readonly resolution: string | null;
      readonly resolutionStatus: StorecastDeviceInfoStatus;
      readonly time: number | null;
      readonly timeStatus: StorecastDeviceInfoStatus;
      readonly timeZone: string | null;
      readonly timeZoneStatus: StorecastDeviceInfoStatus;
      readonly userAgentStatus: StorecastDeviceInfoStatus;
    };
  } | null;
};
export type InfoSubscription = {
  response: InfoSubscription$data;
  variables: InfoSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "screenId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "screenId",
    "variableName": "screenId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "StorecastDeviceInfo",
  "kind": "LinkedField",
  "name": "info",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "languageStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resolution",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resolutionStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "time",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeZone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeZoneStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userAgentStatus",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InfoSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "storecastScreenInfoChange",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InfoSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "storecastScreenInfoChange",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f3f2f58972725db9df60699514b3d322",
    "id": null,
    "metadata": {},
    "name": "InfoSubscription",
    "operationKind": "subscription",
    "text": "subscription InfoSubscription(\n  $screenId: ID!\n) {\n  storecastScreenInfoChange(screenId: $screenId) {\n    info {\n      language\n      languageStatus\n      resolution\n      resolutionStatus\n      time\n      timeStatus\n      timeZone\n      timeZoneStatus\n      userAgentStatus\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f7d3bf25eb5e98e3d13c53cbc3e3f6e8";

export default node;
